import React from 'react';
import { UserPlus } from 'lucide-react';
import api from '../api';

const RoleManagement = () => {
    const [users, setUsers] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const roles = [
        { value: 'CG', label: 'Coordinadora General' },
        { value: 'CO', label: 'Coordinador Operativo' },
        { value: 'ACO', label: 'Auxiliar de la Coordinadora Operativa' },
        { value: 'CD', label: 'Coordinador de Diplomatura' },
        { value: 'RM', label: 'Referente Municipal' },
        { value: 'DO', label: 'Docente' },
        { value: 'AL', label: 'Alumno' },
        { value: 'CA', label: 'Coordinadora Académica' },
    ];

    React.useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const res = await api.get('users/');
            setUsers(res.data);
        } catch (err) {
            console.error(err);
        }
        setLoading(false);
    };

    const handleRoleChange = async (userId, newRole) => {
        try {
            await api.patch(`users/${userId}/set_role/`, { role: newRole });
            fetchUsers();
        } catch (err) {
            alert('Error al asignar rol');
        }
    };

    return (
        <div className="main-content-area p-4 animate-fade-in">
            <div className="content-card glassmorphism p-4">
                <h3 className="mb-4 d-flex align-items-center section-title"><UserPlus className="me-2" /> Asignación de Roles (Auxiliar CO)</h3>
                <div className="table-responsive">
                    <table className="table premium-table">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Rol Actual</th>
                                <th>Asignar Nuevo Rol</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(u => (
                                <tr key={u.id}>
                                    <td>{u.email}</td>
                                    <td>{roles.find(r => r.value === u.role)?.label || u.role}</td>
                                    <td>
                                        <select 
                                            className="form-select form-select-sm"
                                            value={u.role}
                                            onChange={(e) => handleRoleChange(u.id, e.target.value)}
                                        >
                                            {roles.map(r => (
                                                <option key={r.value} value={r.value}>{r.label}</option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RoleManagement;
